<template>
  <div class="cms-empty-view">
    <div class="cms-empty-view__text">暂无内容或栏目类型未配置</div>
  </div>
</template>

<script>
export default {
  name: 'CmsEmptyView',
}
</script>

<style scoped lang="scss">
.cms-empty-view {
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/cms/placeholders/CmsEmptyView.vue